//Handle load-more-button on Blog page
(function () {
  document.querySelectorAll(".js-load-more-article").forEach((btn) => {
    btn.addEventListener("click", (e) => {
      const blogArticles = document.querySelector(".blog-articles--stack");
      const next_url = blogArticles.dataset.nextUrl;
      const elm = e.currentTarget;
      elm.setAttribute("disabled", "disabled");

      fetch(next_url, {
        method: "GET",
        headers: {
          "Content-Type": "text/html",
        },
      })
        .then((response) => response.text())
        .then((next_page) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(next_page, "text/html");
          const new_products = doc.querySelector(".blog-articles--stack");
          const new_url = new_products.dataset.nextUrl;
          const total_page = new_products.dataset.totalPage;
          const current_page = new_products.dataset.currentPage;
          const number_total_page = parseInt(total_page);
          const number_current_page = parseInt(current_page);

          blogArticles.dataset.nextUrl = new_url;
          blogArticles.insertAdjacentHTML("beforeend", new_products.innerHTML);
          blogArticles.setAttribute("data-current-page", current_page);
          elm.removeAttribute("disabled");

          if (number_current_page >= number_total_page) {
            elm.classList.add("hidden");
          }
        });
    });
  });
})();
